import Layout from "../../components/Layout";
import Title from "shared/components/Title";
import IEC61850Client from "../../images/systemComponents/IEC61850Client.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61850 (Клиент)
                </h1>


                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Клиент МЭК 61850 </b> в SCADA NPT Compact используется для взаимодействия с интеллектуальными электронными устройствами (IED) в энергетических системах.
                    </p>
                    <img
                        src={IEC61850Client}

                        className="mb-4 w-100 "
                        alt="IEC61850 Клиент"
                    />

                    <p>Варианты применения:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li">Сбор данных:
                            <ul>
                                <li>Клиент МЭК 61850 подключается к IED и собирает данные в реальном времени (например, напряжение, ток, состояние оборудования).</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">Мониторинг и управление:
                            <ul>
                                <li>
                                    SCADA NPT Compact использует клиента МЭК 61850 для мониторинга состояния энергетической сети и удалённого управления устройствами (например, включение/выключение выключателей).
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">Стандартизация:
                            <ul>
                                <li>
                                    МЭК 61850 обеспечивает единый стандарт обмена данными, что упрощает интеграцию устройств от разных производителей.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">События и аварии:
                            <ul>
                                <li>
                                    Клиент МЭК 61850 получает данные о событиях пусков и срабатываний защит и автоматики, что позволяет оперативно реагировать на изменения в сети.
                                </li>
                            </ul>
                        </li>

                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'МЭК 61850 (Клиент)',
    description: 'Клиент МЭК 61850 в SCADA NPT Compact используется для взаимодействия с интеллектуальными электронными устройствами (IED) в энергетических системах.'
}
//export const doNotPrerender = false;